export { InformationTable } from './InformationTable/InformationTable'
